import { useCurrentOrg } from '@/components/auth/hooks/useCurrentOrg'

export const useIsOrg = () => {
  const { id: orgId } = useCurrentOrg()
  return {
    isUberOrg: orgId === 100756,
  }
}
